import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DialogContent, DialogActions, DialogTitle } from 'Views/Page/Content/Modal/Components';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDPrimaryActionButton, Stack } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorderRadius } from 'Components/utils';
import { dataAttrs } from 'Helpers/Testing';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';

const useStyles = buildUseStyles('Impact', (theme) => ({
  // Paper color=info is the wrong color, so this is the substitute
  betterPaperInfoColor: {
    background: theme.palette.facet.oceana50,
    ...getBorderRadius(theme.radius.md, { all: true }),
    padding: theme.spacing(2),
  },
}));

export const MissingAccountsAndRealAssets = () => {
  const { resource } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();
  const classes = useStyles();
  const noContent = !resource.attr('contentTitle') && !resource.attr('content');


  function handleOnChange() {
    loadModalCollectionByLink(resource.relationship(fr.relationships.accountToLink.name).link('related').url());
  }

  return (
    <>
      <DialogTitle value={resource.attr('title')} />
      <DialogContent>
        {noContent
          ? null
          : (
            <Stack direction={'column'}>
              <div className={classes.betterPaperInfoColor}>
                <Stack direction={'column'}>
                  <MetaControlField attr={'contentTitle'} />
                  <MetaControlField attr={'content'} />
                </Stack>
              </div>
            </Stack>
          )}
      </DialogContent>
      <DialogActions>
        <FDPrimaryActionButton
          {...dataAttrs('continue-btn', resource)}
          label="Continue →"
          onClick={handleOnChange}
          loading={false}
        />
      </DialogActions>
    </>
  );
};
